<template>
  <v-card class="ma-3">
    <v-data-table :headers="headers" :items="lista_tabella">
      <!-- Titolo tabella -->
      <template v-slot:top>
        <!-- Toolbar di Myrepair -->
        <v-toolbar class="sfondoStandard" dense>
          <v-toolbar-title class="white--text">
            Calendario Interventi
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="goToCalendar"
                class="mr-5"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="primary">mdi-calendar-month</v-icon></v-btn
              >
            </template>
            <span>Visualizza Calendario</span>
          </v-tooltip>
          <v-spacer></v-spacer> -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="filtro_visible = true"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="primary">mdi-filter</v-icon></v-btn
              >
            </template>
            <span>Visualizza Filtri</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="resetFiltro" small v-bind="attrs" v-on="on"
                ><v-icon color="primary">mdi-filter-off</v-icon></v-btn
              >
            </template>
            <span>Resetta Filtro</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="goToCalendar" small v-bind="attrs" v-on="on"
                ><v-icon color="error">mdi-keyboard-backspace</v-icon></v-btn
              >
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pt-5">
          <v-row align="center" justify="center" v-if="filtro_visible">
            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="interventions.filter((i) => i.des_intervento != null)"
                :item-text="(item) => item.des_intervento"
                :item-value="(item) => item.des_intervento"
                label="Titolo Intervento"
                style="display: inline-block; max-width: 350px"
                v-model="titolo_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      titolo_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{ titolo_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="interventions.filter((i) => i.des_barca != null)"
                :item-text="(item) => item.des_barca"
                :item-value="(item) => item.des_barca"
                label="Barca"
                style="display: inline-block; max-width: 350px"
                v-model="barca_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      barca_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{ barca_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="interventions.filter((i) => i.matricola != null)"
                :item-text="(item) => item.matricola"
                :item-value="(item) => item.matricola"
                label="Matricola"
                style="display: inline-block; max-width: 350px"
                v-model="matricola_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      matricola_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      matricola_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="interventions.filter((i) => i.modello != null)"
                :item-text="(item) => item.modello"
                :item-value="(item) => item.modello"
                label="Modello"
                style="display: inline-block; max-width: 350px"
                v-model="modello_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      modello_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      modello_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="interventions.filter((i) => i.marca != null)"
                :item-text="(item) => item.marca"
                :item-value="(item) => item.marca"
                label="Marca"
                style="display: inline-block; max-width: 350px"
                v-model="marca_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      marca_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{ marca_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="interventions.filter((i) => i.zona_geografica != null)"
                :item-text="(item) => item.zona_geografica"
                :item-value="(item) => item.zona_geografica"
                label="Zona Geografica"
                style="display: inline-block; max-width: 350px"
                v-model="zona_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      zona_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{ zona_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="interventions.filter((i) => i.ragione_sociale != null)"
                :item-text="(item) => item.ragione_sociale"
                :item-value="(item) => item.ragione_sociale"
                label="Fornitore"
                style="display: inline-block; max-width: 350px"
                v-model="fornitore_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      fornitore_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      fornitore_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-menu
                v-model="calendario_data_prevista_da"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="289"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    background-color="#ffffff"
                    @change="filtra"
                    dense
                    hide-details
                    label="Data Schedulata"
                    style="display: inline-block; max-width: 170px"
                    v-model="data_prevista_da_search_formatted"
                    readonly
                    v-on="on"
                  >
                    <template v-slot:append>
                      <v-icon
                        class="ml-2"
                        @click="
                          data_prevista_da_search = '';
                          filtra();
                        "
                        color="primary"
                        >{{
                          data_prevista_da_search == ""
                            ? "mdi-filter"
                            : "mdi-filter-off"
                        }}</v-icon
                      >
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  @change="filtra"
                  v-model="data_prevista_da_search"
                  no-title
                  locale="it"
                  first-day-of-week="1"
                  @input="calendario_data_prevista_da = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- <v-col cols="4" md="2">
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="lista_interventi"
                item-text="stato"
                item-value="stato"
                label="Stato"
                style="display: inline-block; max-width: 350px"
                v-model="stato_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      stato_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{ stato_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col> -->
          </v-row>
        </v-card-text>
      </template>

      <template v-slot:[`item.data_prevista`]="props">
        <v-edit-dialog
          :return-value.sync="props.item.data_prevista"
          @save="updateDataPrevista(props.item)"
        >
          {{ props.item.data_prevista }}
          <template v-slot:input>
            <v-menu
              v-model="calendario_data_prevista_intervento"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="289"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="props.item.data_prevista"
                  label="Modifica"
                  single-line
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="props.item.data_prevista"
                no-title
                locale="it"
                first-day-of-week="1"
                @input="
                  (calendario_data_prevista_intervento = false),
                    checkData(intervento_sel)
                "
              ></v-date-picker>
            </v-menu>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:[`item.data_schedulata`]="props">
        <v-edit-dialog
          :return-value.sync="props.item.data_schedulata"
          @save="updateDataSchedulata(props.item)"
        >
          {{ props.item.data_schedulata }}
          <template v-slot:input>
            <v-menu
              v-model="calendario_data_schedulata_intervento"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="289"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="props.item.data_schedulata"
                  label="Modifica"
                  single-line
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="props.item.data_schedulata"
                no-title
                locale="it"
                first-day-of-week="1"
                @input="
                  (calendario_data_schedulata_intervento = false),
                    checkData(intervento_sel)
                "
              ></v-date-picker>
            </v-menu>
          </template>
        </v-edit-dialog>
      </template>

      <!-- Bottone dialog di modifica intervento -->
      <!-- <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickModificaIntervento(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Mostra Dettagli</span>
        </v-tooltip>
      </template> -->
    </v-data-table>

    <v-dialog v-model="modifica_intervento_visible">
      <v-card>
        <v-toolbar
          color="indigo"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-toolbar-title class="white--text">
            Modifica Intervento
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaIntervento"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Intervento</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiudiModificaIntervento"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pb-5 px-5 py-0">
          <v-tabs class="mt-5" v-model="tab_intervento" align-with-title>
            <v-tabs-slider color="transparent"></v-tabs-slider>
            <v-tab
              active-class="py-0 my-0 indigo white--text"
              class="py-0 my-0"
              v-for="item in tabs_intervento"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab_intervento">
            <v-tab-item>
              <v-card elevation="2" outlined class="mx-0 py-4">
                <v-row class="mx-5">
                  <v-col cols="6">
                    <v-text-field
                      label="Titolo Intervento"
                      v-model="intervento_sel.des_intervento"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="3">
                    <v-text-field
                      :disabled="
                        intervento_sel.cod_stato_richiesta == 'FINISH'
                          ? true
                          : false
                      "
                      label="Referente"
                      v-model="intervento_sel.des_referente"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete
                      :disabled="intervento_sel.id_stato_operativo == null"
                      :items="stato_intervento_lista_disponibile"
                      label="Stato Intervento"
                      placeholder="Seleziona"
                      item-text="des"
                      item-value="id_tabella"
                      required
                      v-model="intervento_sel.id_stato_operativo"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-row class="mx-5">
                  <v-col cols="3">
                    <v-autocomplete
                      @change="associaIdTipoIntervento"
                      v-model="intervento_sel.id_tipo_intervento"
                      :items="ambito_manutentivo_lista"
                      label="Ambito Manutentivo"
                      :disabled="
                        intervento_sel.attivita.length > 0
                          ? true
                          : false ||
                            intervento_sel.cod_stato_richiesta == 'FINISH'
                      "
                      placeholder="Seleziona"
                      item-text="des"
                      item-value="id_tabella"
                      required
                    >
                      <template #label>
                        <span class="">Ambito Manutentivo</span>
                        <span
                          @click.stop
                          style="min-width: 500px; pointer-events: all"
                        >
                          <Modules
                            v-on:dialogModules="gettabelle"
                            tipo="MAN_AMBITO_MANUTENTIVO"
                            nome="Ambito Manutentivo"
                            setaction="settabella"
                            getaction="gettabella"
                            controller="Global"
                            filter="validita = 1"
                            :dati="[{ des: '' }]"
                          />
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete
                      :disabled="
                        intervento_sel.cod_stato_richiesta == 'FINISH'
                          ? true
                          : false
                      "
                      v-model="intervento_sel.id_tipo_manutenzione"
                      :items="tipo_manutenzione_lista"
                      label="Tipo Manutenzione"
                      placeholder="Seleziona"
                      item-text="des"
                      item-value="id_tabella"
                      required
                    >
                      <template #label>
                        <span class="">Tipo Manutenzione</span>
                        <span
                          @click.stop
                          style="min-width: 500px; pointer-events: all"
                        >
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete
                      @change="getFornitoreIntervento(intervento_sel)"
                      :items="concessionari_lista"
                      item-text="des"
                      item-value="id_tabella"
                      label="Concessionari"
                      v-model="intervento_sel.id_concessionario"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete
                      @change="associaFornitore(fornitore_sel)"
                      class="mt-n1"
                      :items="fornitore_lista"
                      item-text="ragione_sociale"
                      item-value="id_fornitore"
                      label="Fornitori"
                      :menu-props="{ maxHeight: '400' }"
                      :readonly="
                        intervento_sel.attivita.length > 0
                          ? true
                          : false ||
                            intervento_sel.cod_stato_richiesta == 'FINISH'
                      "
                      v-model="fornitore_sel"
                    >
                      <template v-slot:append>
                        <v-btn
                          class="ma-0 pa-0"
                          @click="clickDettaglioFornitore"
                          icon
                        >
                          <v-icon color="primary"> mdi-account </v-icon>
                        </v-btn>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-row class="mx-5">
                  <v-col cols="3">
                    <v-menu
                      :disabled="
                        intervento_sel.cod_stato_richiesta == 'FINISH'
                          ? true
                          : false
                      "
                      v-model="calendario_data_prevista_intervento"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="289"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="
                            intervento_sel.cod_stato_richiesta == 'FINISH'
                              ? true
                              : false
                          "
                          background-color="#ffffff"
                          hide-details
                          label="Data Prevista"
                          v-model="intervento_sel.data_prevista"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        :disabled="
                          intervento_sel.cod_stato_richiesta == 'FINISH'
                            ? true
                            : false
                        "
                        v-model="intervento_sel.data_prevista"
                        no-title
                        locale="it"
                        first-day-of-week="1"
                        :min="intervento_sel.data_richiesta"
                        @input="
                          (calendario_data_prevista_intervento = false),
                            checkData(intervento_sel)
                        "
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="3">
                    <v-menu
                      :disabled="
                        intervento_sel.cod_stato_richiesta == 'FINISH'
                          ? true
                          : false
                      "
                      v-model="calendario_data_schedulata_intervento"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="289"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="
                            intervento_sel.cod_stato_richiesta == 'FINISH'
                              ? true
                              : false
                          "
                          background-color="#ffffff"
                          hide-details
                          label="Data Schedulata"
                          v-model="intervento_sel.data_schedulata"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        :disabled="
                          intervento_sel.cod_stato_richiesta == 'FINISH'
                            ? true
                            : false
                        "
                        v-model="intervento_sel.data_schedulata"
                        no-title
                        locale="it"
                        first-day-of-week="1"
                        :min="intervento_sel.data_prevista"
                        @input="calendario_data_schedulata_intervento = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="3">
                    <v-menu
                      ref="menu_ora_schedulata"
                      v-model="menu_ora_schedulata"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="intervento_sel.ora_schedulata"
                      :disabled="
                        intervento_sel.cod_stato_richiesta == 'FINISH'
                          ? true
                          : false
                      "
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="intervento_sel.ora_schedulata"
                          label="Ora Schedulata"
                          prepend-inner-icon="access_time"
                          :disabled="
                            intervento_sel.cod_stato_richiesta == 'FINISH'
                              ? true
                              : false
                          "
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        format="ampm"
                        v-if="menu_ora_schedulata"
                        v-model="intervento_sel.ora_schedulata"
                        full-width
                        @click:minute="
                          $refs.menu_ora_schedulata.save(
                            intervento_sel.ora_schedulata
                          )
                        "
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    v-if="
                      intervento_sel.id_stato_operativo == id_stato_ordinato
                    "
                    cols="3"
                  >
                    <v-text-field
                      label="Numero d'Ordine"
                      v-model="intervento_sel.numero_ordine"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mx-5">
                  <v-col class="pb-0" cols="12">
                    <v-text-field
                      :disabled="
                        this.intervento_sel.cod_stato_richiesta == 'FINISH'
                          ? true
                          : false
                      "
                      label="Annotazioni"
                      outlined
                      v-model="intervento_sel.note"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mx-5">
                  <v-col cols="6" md="2">
                    <v-text-field
                      disabled
                      v-model="des_sede_intervento_sel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="2">
                    <v-text-field
                      disabled
                      v-model="des_struttura_intervento_sel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="2">
                    <v-text-field
                      disabled
                      v-model="des_area_intervento_sel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="2">
                    <v-text-field
                      disabled
                      v-model="des_zona_intervento_sel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="2">
                    <v-text-field
                      disabled
                      v-model="des_stanza_intervento_sel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="2">
                    <v-text-field
                      disabled
                      v-model="des_macchina_interento_sel"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mx-5">
                  <v-col cols="12">
                    <DettaglioAttivita
                      @aggiorna_attivita="aggiornaAttivita"
                      :intervento="intervento_sel"
                      :fornitori="intervento_sel.fornitori"
                      ref="dettaglio_attivita"
                      :attivita="attivita_intervento"
                      :stato_approvato_id="stato_approvato_id"
                      :stato_rifiutato_id="stato_rifiutato_id"
                      :stato_sospeso_id="stato_sospeso_id"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <GestioneAllegato
                controller_allegati="Global"
                controller_caratteristiche_tabella="Manutenzione"
                :id_riferimento="intervento_sel.id_intervento"
                ref="componenteAllegati"
                @snackbarOpen="snackbarOpen"
                tipo_allegato="INTERVENTO"
                :read_only="
                  intervento_sel.cod_stato_richiesta == 'FINISH' ? true : false
                "
              />
            </v-tab-item>
            <v-tab-item>
              <GestioneAllegato
                controller_allegati="Global"
                controller_caratteristiche_tabella="Manutenzione"
                :id_riferimento="intervento_sel.id_richiesta"
                :read_only="true"
                @snackbarOpen="snackbarOpen"
                tipo_allegato="RICHIESTA"
              />
            </v-tab-item>

            <!-- Tab della Descrizione Richiesta -->
            <v-tab-item>
              <v-card elevation="3" outlined class="mx-4 mb-3 py-4">
                <v-container>
                  <v-row>
                    <v-textarea
                      class="mx-5"
                      label="Problema"
                      outlined
                      readonly
                      v-model="intervento_sel.descrizione"
                    ></v-textarea>
                  </v-row>
                  <!-- Textarea della Soluzione -->
                  <v-row>
                    <v-textarea
                      class="mx-5"
                      label="Soluzione"
                      outlined
                      readonly
                      v-model="intervento_sel.soluzione"
                    ></v-textarea>
                  </v-row>
                </v-container>
              </v-card>
            </v-tab-item>

            <!-- Tab della bacheca -->
            <v-tab-item>
              <Bacheca
                :id="intervento_sel.id_intervento"
                :tipo="'intervento'"
                :visible="modifica_intervento_visible"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <TabellaAnagrafiche
      :concessionari_visible="true"
      ref="TabellaAnagrafiche"
      v-show="false"
    >
    </TabellaAnagrafiche>

    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import Bacheca from "@/components/MANUTENZIONE/Bacheca.vue";
import DettaglioAttivita from "@/components/MANUTENZIONE/DettaglioAttivita.vue";
import TabellaAnagrafiche from "@/components/MANUTENZIONE/TabellaAnagrafiche.vue";
import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

import moment from "moment/moment";
import Intervention from "@/classes/Intervention.js";
// import Registry from "@/classes/Registry.js";
import Request from "@/classes/Request.js";

export default {
  name: "TabellaListaInterventi",
  props: {
    rotta_back: {
      type: String,
      default: "/home/manutenzione/main",
    },
  },
  components: {
    Bacheca,
    DettaglioAttivita,
    GestioneAllegato,
    Modules: () => import("@/components/TOOLS/Modules"),
    SnackbarQV,
    TabellaAnagrafiche,
  },
  data() {
    return {
      data_prevista_da_search: "",
      data_prevista_a_search: "",

      data_prevista_da_search_formatted: "",
      data_prevista_a_search_formatted: "",

      intervento_sel: new Intervention(),

      richiesta_sel: new Request(),
      stato_approvato_id: null,
      stato_sospeso_id: null,
      stato_rifiutato_id: null,
      id_stato_ordinato: null,

      richiesta_readOnly: false,

      modifica_intervento_visible: false,
      calendario_data_prevista_da: false,
      calendario_data_prevista_a: false,
      dialog_modifica_visible: false,
      filtro_visible: false,

      ambito_manutentivo_lista: [],
      stato_intervento_lista: [],
      stato_intervento_lista_disponibile: [],
      tipo_manutenzione_lista: [],
      urgenza_lista: [],
      fornitore_lista: [],
      attivita_intervento: [],
      concessionari_lista: [],
      lista_tabella: [],
      interventions: [],

      des_macchina_interento_sel: "",
      des_stanza_intervento_sel: "",
      des_zona_intervento_sel: "",
      des_area_intervento_sel: "",
      des_struttura_intervento_sel: "",
      des_sede_intervento_sel: "",

      calendario_data_prevista_intervento: false,
      calendario_data_schedulata_intervento: false,
      menu_ora_schedulata: false,
      tab_intervento: [],
      tabs_intervento: [],
      fornitore_sel: null,

      titolo_search: "",
      barca_search: "",
      matricola_search: "",
      marca_search: "",
      modello_search: "",
      fornitore_search: "",
      zona_search: "",
      data_prevista_start_search: "",
      // data_prevista_end_search: "",
      // stato_search: "",

      headers: [
        // {
        //   text: "Modifica",
        //   value: "modifica",
        //   sortable: false,
        // },
        {
          text: "Titolo Intervento",
          value: "des_intervento",
        },
        {
          text: "Barca",
          value: "des_barca",
        },
        {
          text: "Matricoloa",
          value: "matricola",
        },
        {
          text: "Modello",
          value: "modello",
        },
        {
          text: "Marca",
          value: "marca",
        },
        {
          text: "Zona Geografica",
          value: "zona_geografica",
        },
        // {
        //   text: "Ambito Manutenzione",
        //   value: "des_tipo_intervento",
        // },
        // {
        //   text: "Tipo Manutenzione",
        //   value: "des_tipo_manutenzione",
        // },
        {
          text: "Fornitore",
          value: "ragione_sociale",
        },
        {
          text: "Data Schedulata",
          value: "data_schedulata",
        },
      ],
    };
  },
  watch: {
    data_prevista_da_search(val) {
      this.data_prevista_da_search_formatted = this.formatDate(val);
    },
    data_prevista_a_search(val) {
      this.data_prevista_a_search_formatted = this.formatDate(val);
    },
  },
  mounted() {
    this.getInterventions();
    // this.tabs_intervento = [
    //   "Generale",
    //   "Allegati",
    //   "Allegati Richiesta",
    //   "Des. Richiesta",
    //   "Bacheca",
    //   "Costi",
    // ];

    // this.gettabelle();
    // this.callList();
  },
  methods: {
    checkData(intervento_sel) {
      let date_preview = new Date(intervento_sel.data_prevista);
      let date_final = new Date(intervento_sel.data_schedulata);
      if (date_final < date_preview) {
        this.intervento_sel.data_schedulata = this.intervento_sel.data_prevista;
      }
    },
    getInterventions() {
      let richiesta = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getcalendariointerventi",
          token: localStorage.user_token,
        },
      };
      this.$store.dispatch("api", richiesta).then((res) => {
        if (res.status === 200) {
          this.interventions = [];
          this.interventions = res.data.intervention;

          this.interventions.forEach((i) => {
            if (i.data_schedulata) {
              i.data_schedulata = i.data_schedulata.split("T")[0];
            }
          });
          this.lista_tabella = this.interventions;
        } else {
          this.snackbar = true;
          this.messaggio_snackbar = "Nessun elemento trovato!";
          this.colore_snack = "orange";
        }
      });
    },
    goBack() {
      this.$router.push(this.rotta_back);
    },
    resetFiltro() {
      // Resetto i filtri
      this.titolo_search = "";
      this.barca_search = "";
      this.matricola_search = "";
      this.modello_search = "";
      this.marca_search = "";
      this.zona_search = "";
      this.fornitore_search = "";
      this.data_prevista_da_search = "";
      this.data_prevista_a_search = "";
      this.data_prevista_da_search_formatted = "";
      this.data_prevista_a_search_formatted = "";

      // Nascondo i filtri
      this.filtro_visible = false;

      this.lista_tabella = this.interventions;
    },
    getFornitoreIntervento(arg) {
      if (this.tipo_getfornitori === "standard") {
        console.log("entrato getfornitore intervento", this.tipo_getfornitori);
        let request = {
          controller: "Manutenzione",
          method: "POST",
          richiesta: {
            action: "getfornitoreintervento",
            token: localStorage.user_token,
            id_sede: this.id_sede_intervento_sel,
            id_struttura: this.id_struttura_intervento_sel,
            id_ambito_manutenzione: arg.id_tipo_intervento,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            this.fornitore_lista = res.data.result;
            // Rinomino il campo id_anagrafica per convenienza di BE sul salvataggio
            this.fornitore_lista.forEach((fornitore) => {
              fornitore.id_fornitore = fornitore.id_anagrafica;
              delete fornitore.id_anagrafica;
            });
            //this.intervento_sel.fornitori = this.fornitore_lista;
          } else {
            this.fornitore_lista = [];
            this.snackbar_richiesta = true;
            this.snackbar_background = "orange";
            this.snackbar_icon = "mdi-alert";
            this.snackbar_icon_color = "white";
            this.snackbar_text =
              "Non è stato trovato nessun fornitore autorizzato a operare in questa sede / struttura specializzato per questo ambito manutentivo.";
            this.snackbar_text_color = "white";
          }
        });
      } else if (
        this.tipo_getfornitori === "digitalmarine" &&
        this.intervento_sel.id_concessionario != null &&
        arg.id_tipo_intervento != null
      ) {
        let request = {
          controller: "Manutenzione",
          method: "POST",
          richiesta: {
            action: "getfornitoridigitalmarine",
            token: localStorage.user_token,
            id_concessionario: this.intervento_sel.id_concessionario,
            id_ambito_manutenzione: arg.id_tipo_intervento,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            this.fornitore_lista = res.data.result;
            // Rinomino il campo id_anagrafica per convenienza di BE sul salvataggio
            this.fornitore_lista.forEach((fornitore) => {
              fornitore.id_fornitore = fornitore.id_anagrafica;
              delete fornitore.id_anagrafica;
            });
            //this.intervento_sel.fornitori = this.fornitore_lista;
          } else {
            this.fornitore_lista = [];
            this.snackbar_richiesta = true;
            this.snackbar_background = "orange";
            this.snackbar_icon = "mdi-alert";
            this.snackbar_icon_color = "white";
            this.snackbar_text =
              "Non è stato trovato nessun fornitore autorizzato a operare in questa sede / struttura specializzato per questo ambito manutentivo.";
            this.snackbar_text_color = "white";
          }
        });
      }
    },
    // getInterventoDettaglio(arg, arg_tipo = "intdettaglio") {
    //   let request = {
    //     controller: "Manutenzione",
    //     method: "POST",
    //     richiesta: {
    //       action: "getinterventodettaglio",
    //       token: localStorage.user_token,
    //       id_regola: arg.id_regola,
    //       id_intervento: arg.id_intervento,
    //     },
    //   };

    //   this.$store.dispatch("api", request).then((res) => {
    //     if (res.status === 200) {
    //       if (res.data.result.fornitori) {
    //         res.data.result.fornitori.forEach((fornitore) => {
    //           arg.fornitori.push(fornitore.id_fornitore);
    //         });
    //         arg.consuntivo = res.data.result.consuntivo;
    //         this.attivita_intervento = res.data.result.attivita;

    //         /* Inserisco nelle attività un campo che le collega al
    //          * consuntivo dell'intervento; questa informazione risulta
    //          * utile al BE in fase di salvataggio (chiamata setattivita).*/
    //         this.attivita_intervento.forEach((attivita) => {
    //           attivita.id_consuntivo = arg.id_consuntivo;
    //         });

    //         this.fornitori_confronto = res.data.result.fornitori;
    //         this.fornitore_sel = res.data.result.fornitori[0];
    //         this.intervento_sel.fornitori = res.data.result.fornitori;

    //         this.items_allegati = res.data.result.allegati_intervento;
    //         this.intervento_sel.allegati = res.data.result.allegati_intervento;
    //       }

    //       /* Faccio una chiamata per valorizzare la select
    //        * dei fornitori passibili di chiamata per le attività. */
    //       if (arg_tipo === "intdettaglio") {
    //         this.getFornitoreIntervento(arg);
    //       }
    //     }
    //   });
    // },
    // clickModificaIntervento(item) {
    //   if (
    //     item.cod_stato_operativo === "WIP" &&
    //     (localStorage.cod_profilo == "GOD" ||
    //       localStorage.cod_profilo == "SVIL" ||
    //       localStorage.cod_profilo == "Admin" ||
    //       localStorage.cod_profilo == "OPJ" ||
    //       localStorage.cod_profilo == "OPS")
    //   ) {
    //     this.stato_intervento_lista_disponibile =
    //       this.stato_intervento_lista.filter(
    //         (elem) =>
    //           elem.cod === "UNDEFINED" ||
    //           elem.cod === "WAIT_MAT" ||
    //           elem.cod === "REQ" ||
    //           elem.cod === "CANT_DO" ||
    //           elem.cod === "WIP" ||
    //           elem.cod === "COMPL"
    //       );
    //   } else if (
    //     (item.cod_stato_operativo === "UNDEFINED" ||
    //       item.cod_stato_operativo === "WAIT_MAT" ||
    //       item.cod_stato_operativo === "REQ" ||
    //       item.cod_stato_operativo === "CANT_DO") &&
    //     (localStorage.cod_profilo == "GOD" ||
    //       localStorage.cod_profilo == "SVIL" ||
    //       localStorage.cod_profilo == "Admin" ||
    //       localStorage.cod_profilo == "OPJ" ||
    //       localStorage.cod_profilo == "OPS")
    //   ) {
    //     this.stato_intervento_lista_disponibile =
    //       this.stato_intervento_lista.filter(
    //         (elem) =>
    //           elem.cod === "UNDEFINED" ||
    //           elem.cod === "WAIT_MAT" ||
    //           elem.cod === "REQ" ||
    //           elem.cod === "CANT_DO" ||
    //           elem.cod === "COMPL"
    //       );
    //   } else if (
    //     item.cod_stato_operativo === "COMPL" &&
    //     (localStorage.cod_profilo == "GOD" ||
    //       localStorage.cod_profilo == "Admin" ||
    //       localStorage.cod_profilo == "SVIL") &&
    //     item.preventivo == 0 &&
    //     item.interno == 0
    //   ) {
    //     this.stato_intervento_lista_disponibile =
    //       this.stato_intervento_lista.filter(
    //         (elem) => elem.cod === "CONS" || elem.des === "COMPL"
    //       );
    //   } else if (
    //     item.cod_stato_operativo === "CONS" &&
    //     (localStorage.cod_profilo == "GOD" ||
    //       localStorage.cod_profilo == "SVIL" ||
    //       localStorage.cod_profilo == "AMM" ||
    //       localStorage.cod_profilo == "Admin" ||
    //       localStorage.cod_profilo == "BOSS")
    //   ) {
    //     this.stato_intervento_lista_disponibile =
    //       this.stato_intervento_lista.filter(
    //         (elem) =>
    //           elem.cod === "CONS" || elem.cod === "VALID" || elem.cod === "REV"
    //       );
    //   } else if (
    //     item.cod_stato_operativo === "VALID" &&
    //     (localStorage.cod_profilo == "GOD" ||
    //       localStorage.cod_profilo == "SVIL" ||
    //       localStorage.cod_profilo == "AMM" ||
    //       localStorage.cod_profilo == "Admin" ||
    //       localStorage.cod_profilo == "BOSS")
    //   ) {
    //     this.stato_intervento_lista_disponibile =
    //       this.stato_intervento_lista.filter(
    //         (elem) => elem.cod === "ORDER" || elem.cod === "VALID"
    //       );
    //   } else {
    //     this.stato_intervento_lista_disponibile =
    //       this.stato_intervento_lista.filter(
    //         (elem) => elem.cod === item.cod_stato_operativo
    //       );
    //   }

    //   // Registro l'intervento selezionato
    //   this.intervento_sel = new Intervention(item);

    //   // Resetto il fornitore_sel
    //   this.fornitore_sel = null;

    //   /* Faccio una chiamata per avere i fornitori,
    //    * le attività, gli allegati e definire altri
    //    * dettagli di supporto dell'intervento. */
    //   this.getInterventoDettaglio(this.intervento_sel);

    //   this.intervento_sel.id_sede = this.id_sede_intervento_sel;
    //   this.intervento_sel.id_struttura = this.id_struttura_intervento_sel;
    //   this.intervento_sel.id_area = this.id_area_intervento_sel;
    //   this.intervento_sel.id_zona = this.id_zona_intervento_sel;
    //   this.intervento_sel.id_stanza = this.id_stanza_intervento_sel;
    //   this.intervento_sel.id_macchinario = this.id_macchinario_intervento_sel;
    //   this.intervento_sel.des_sede = this.des_sede_intervento_sel;
    //   this.intervento_sel.des_struttura = this.des_struttura_intervento_sel;
    //   this.intervento_sel.des_area = this.des_area_intervento_sel;
    //   this.intervento_sel.des_zona = this.des_zona_intervento_sel;
    //   this.intervento_sel.des_stanza = this.des_stanza_intervento_sel;
    //   this.intervento_sel.des_macchinario = this.des_macchina_interento_sel;

    //   // Apro il dialog di modifica
    //   this.modifica_intervento_visible = true;
    // },
    // clickDettaglioFornitore() {
    //   let fornitore_sel_tmp = Object.assign({}, this.fornitore_sel);
    //   fornitore_sel_tmp.id_anagrafica = fornitore_sel_tmp.id_fornitore;
    //   fornitore_sel_tmp = new Registry(fornitore_sel_tmp);

    //   this.$refs.TabellaAnagrafiche.anagrafica_sel = new Registry(
    //     fornitore_sel_tmp
    //   );
    //   this.$refs.TabellaAnagrafiche.clickDettagli(fornitore_sel_tmp);
    // },
    // clickChiudiModificaIntervento() {
    //   this.modifica_intervento_visible = false;
    // },
    // async salvaModificaIntervento() {
    //   this.modifica_intervento_visible = false;
    // },
    filtra() {
      let items_interventi_tmp = [];
      this.interventions.forEach((elem) => {
        items_interventi_tmp.push(elem);
      });

      // Filtro il nome della intervento
      if (this.titolo_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (elem.des_intervento == this.titolo_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
      }

      // Filtro l ambito
      if (this.barca_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (elem.des_barca == this.barca_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
      }

      // Filtro la matricola
      if (this.matricola_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (elem.matricola == this.matricola_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
      }

      // Filtro il modello
      if (this.modello_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (elem.modello == this.modello_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
      }

      // Filtro la marca
      if (this.marca_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (elem.marca == this.marca_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
      }

      // Filtro la zona
      if (this.zona_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (elem.zona_geografica == this.zona_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
      }

      // Filtro il fornitore
      if (this.fornitore_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (elem.ragione_sociale == this.fornitore_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
      }

      // Filtro la data
      if (this.data_prevista_da_search != "") {
        console.log("data", this.data_prevista_da_search);
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_interventi_tmp.forEach((elem) => {
          if (
            moment(elem.data_schedulata) >= moment(this.data_prevista_da_search)
          ) {
            console.log("entra if data");
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_interventi_tmp = res;
        console.log(items_interventi_tmp);
      }

      // if (this.data_prevista_da_search != "") {
      //   this.lista_tabella = this.lista_tabella.filter((el) => {
      //     return moment(el.data_prevista) >= moment(this.data_prevista_da);
      //   });
      // }

      this.lista_tabella = items_interventi_tmp;
    },
    // gettabelle() {
    //   let request = {
    //     controller: "Global",
    //     method: "POST",
    //     richiesta: {
    //       action: "gettabella",
    //       token: localStorage.getItem("user_token"),
    //       tipo: "'MAN_TIPO_MANUTENZIONE','MAN_URGENZA_INTERVENTO','MAN_AMBITO_MANUTENTIVO', 'MAN_CONCESSIONARIO'",
    //       filter: "validita = 1",
    //     },
    //   };

    //   this.$store.dispatch("api", request).then((res) => {
    //     this.concessionari_lista =
    //       res.data.MAN_CONCESSIONARIO != undefined
    //         ? res.data.MAN_CONCESSIONARIO
    //         : [];

    //     this.tipo_manutenzione_lista =
    //       res.data.MAN_TIPO_MANUTENZIONE != undefined
    //         ? res.data.MAN_TIPO_MANUTENZIONE
    //         : [];

    //     this.urgenza_lista =
    //       res.data.MAN_URGENZA_INTERVENTO != undefined
    //         ? res.data.MAN_URGENZA_INTERVENTO
    //         : [];

    //     this.ambito_manutentivo_lista =
    //       res.data.MAN_AMBITO_MANUTENTIVO != undefined
    //         ? res.data.MAN_AMBITO_MANUTENTIVO
    //         : [];
    //   });
    // },
    goToCalendar() {
      this.$router.push("/home/naval/CalendarioEventi");
    },
    aggiornaAttivita() {
      /* Il DettaglioAttivita ha eseguito un aggiornamento dei propri elementi
       * e l'Intervento fa una chiamata per allineare i propri dati. */
      let request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getinterventodettaglio",
          token: localStorage.user_token,
          id_regola: this.intervento_sel.id_regola,
          id_intervento: this.intervento_sel.id_intervento,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          if (res.data.result.attivita) {
            this.attivita_intervento = res.data.result.attivita;
          }
        }
      });
    },
    // updateDataSchedulata(item) {
    //   let request = {
    //     controller: "Manutenzione",
    //     method: "PUT",
    //     richiesta: {
    //       action: "",
    //       id_intervento: item.id_intervento,
    //     },
    //   };

    //   this.$store.dispatch("api", request).then((res) => {
    //     if (res.status === 200) {
    //       this.$refs.SnackbarQV.print();
    //     }
    //   });
    // },
    // updateDataPrevista(item) {
    //   let request = {
    //     controller: "Manutenzione",
    //     method: "PUT",
    //     richiesta: {
    //       action: "",
    //       id_intervento: item.id_intervento,
    //     },
    //   };

    //   this.$store.dispatch("api", request).then((res) => {
    //     if (res.status === 200) {
    //       this.$refs.SnackbarQV.print();
    //     }
    //   });
    // },
    associaIdTipoIntervento() {
      this.ambito_manutentivo_lista.forEach((elem) => {
        if (elem.id_tabella === this.intervento_sel.id_tipo_intervento) {
          this.intervento_sel.des_tipo_intervento = elem.des;
        }
      });

      this.getFornitoreIntervento(this.intervento_sel);
    },
    snackbarOpen() {
      // funzione triggerata per cogliere l'errore degli allegati che non hanno la descrizione inserita
      this.$refs.SnackbarQV.print(
        "orange",
        "Aggiungere ad ogni Allegato dell'attività una descrizione."
      );
    },
    formatDate(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
.sfondoStandard {
  background: linear-gradient(
    90deg,
    rgba(63, 81, 181, 1) 0%,
    rgba(63, 81, 181, 1) 100%
  );
}
</style>
